<template>
    <b-row class="p-1" align-v="end">
        <b-col cols="4">
            <img src="@/assets/logo-small.jpg"
                 class="logo-margin"
                 alt="Ambit Logo"
                 aria-label="Ambit Logo" />
        </b-col>
    </b-row>
</template>

<script>
export default {
  name: "AmbitLogo"      
};
</script>
